import React from 'react';

class LoginError extends React.Component<any> {
  constructor(props: any) {
    super(props);
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('relaystate');
    const data = {
      authStatus: 'failed',
      token,
    };
    window.parent.postMessage(data, '*' );
  }

  render() {
    return '';
  }
}
export default LoginError;
